import { render, staticRenderFns } from "./TeachersStatistic.vue?vue&type=template&id=16d5943f&scoped=true&"
import script from "./TeachersStatistic.vue?vue&type=script&lang=js&"
export * from "./TeachersStatistic.vue?vue&type=script&lang=js&"
import style0 from "./TeachersStatistic.vue?vue&type=style&index=0&id=16d5943f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d5943f",
  null
  
)

export default component.exports